<template>

  <div class="padding-content">

    <div class="padding-content shadow-sm bg-gray-50">
    <loader v-if="preload"></loader>

    <div class="form-group">
      <label for=""><strong>Seleccionar empresa</strong></label>
      <el-select filterable
        v-model="empresa.id"
        @change="cambioEmpresa"
        clearable
        placeholder="Seleccionar empresa"
        no-data-text="No hay datos que coincidan"
        no-match-text="No hay datos que coincidan"
      >
        <el-option v-for="(e, idx) in empresas" v-if="e.asignado" :key="idx" :label="e.nombre" :value="e.id">
        </el-option>
      </el-select>
    </div>

    <div class="row mt-3" v-if="empresa.id">
      <div class="col-12 text-center text-muted" v-if="cargando">
        <i class="fa fa-spin fa-spinner"> </i> Cargando ubicaciones
      </div>
      <div class="col-12 text-center text-muted" v-else-if="empresa.id && !ubicaciones.length">
        <i class="fa fa-exclamation-triangle"></i> La empresa no tiene ubicaciones registradas
      </div>
      <div class="col-md-12 col-sm-12 col-lg-12" v-else-if="ubicaciones.length">
        <strong>Ubicaciones disponibles</strong>
        <b-form-group label="" horizontal>
          <b-form-input v-model="filterText" placeholder="Filtrar ubicaciones"/>
        </b-form-group>
        <el-tree ref="tree"
          :data="ubicaciones"
          v-if="visible_tree"
          show-checkbox
          node-key="id"
          :filter-node-method="filterNode"
          :default-checked-keys="selecionadosIds"
          :expand-on-click-node="false"
          check-strictly
          @check-change="handleCheckChange">

        </el-tree>
      </div>
    </div>
    </div>

    <b-row class="mt-3">
      <b-col>
        <button class="btn btn-secondary float-left" @click="setModalPaso(5)">Anterior</button>
        <button class="btn btn-primary float-right" :disabled="!selecionadosIds.length" @click="saveProduct()">Finalizar</button>
        <button class="btn btn-secondary float-right mr-2" @click="setModalVer(false)">Cancelar</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import Swal from "sweetalert2";
  import loader from "../../../containers/loader"
  import moment from 'moment';
  export default {
    name: 'ubicaciones',
    components: {
      loader
    },
    data: function () {
      return {
        cargando: false,
        empresaSeleccionada: null,
        filterText: '',
        visible_tree: true,
        preload: false,
        selecionadosIds: [],
      };
    },
    computed: {
      ...mapState('adjuntos', ['attachmenteCreated']),
      ...mapState('pasoapaso', [
        'empresas',
        'ubicaciones',
        'empresa',
        'ubicaciones_seleccionadas',
        'producto',
        'adjunto',
        'components',
        'sga',
        'adjunto',
        'epps',
        'empresas'
      ]),
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      }
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },
      async cambioEmpresa(empresa_id) {
        this.cargando = true

        if (empresa_id) {
          let empresa = this.empresas.find(e => e.id === this.empresa.id)
          await this.listarUbicaciones(empresa_id)
          if (empresa.ubicaciones_seleccionadas) {
            this.setUbicacionesSeleccionadas(empresa.ubicaciones_seleccionadas)
          }
        }
        this.cargando = false
      },
      async setChecked(ubicacion) {
        await ubicacion.map(async i => {
          if (i.checked) {
            console.log(i);
            this.addUbicacionSeleccionada(i.id)
          }
          await this.setChecked(i.children)
        })
      },
      async append(data) {
        this.preload = true
        this.visible_tree = false
        data.checked = !data.checked
        this.setUbicacionesSeleccionadas([])
        await this.setChecked(this.ubicaciones)
        this.setUbicacionesEmpresa()

        this.visible_tree = true

        setTimeout(() => {
          this.$refs.tree.filter(this.filterText);
          this.preload = false
        }, 500)
      },
      async saveProduct() {
        try {
          this.producto.verificado = 1;
          this.producto.asignado = 1;
          this.producto.pago = 1;
          this.producto.id_empresa = this.empresa.id;

          // Asignar los componentes temporales al producto
          this.producto.components = this.components;

          this.setModalLoader(true);

          const formData = window.buildFormData(this.producto);
          const doc_etiqueta = (this.sga.categoriasNpeligrosas.length || this.sga.categoriasambiental.length || this.sga.categoriasfisicas.length || this.sga.categoriassalud.length) ? 160 : 161;
          formData.append('doc_etiqueta',doc_etiqueta);
          if (doc_etiqueta === 160) {
            formData.append('fecha_etiqueta',moment().format('YYYY-MM-DD'));
          }

          const doc_sga = this.adjunto.tipo === 154 && (this.adjunto.idioma === 137 || this.adjunto.idioma === 138) ? 160 : 161;
          formData.append('doc_sga',doc_sga);

          if (this.components.length){
            formData.append('components', JSON.stringify(this.components));
          }

          formData.append('action', 'CREATE');
          formData.append('customProcess', true);
          if (this.adjunto.fecha) formData.append('date', this.adjunto.fecha);
          if (this.adjunto.tipo) formData.append('type', this.adjunto.tipo);
          if (this.adjunto.sistema) formData.append('system', this.adjunto.sistema);
          if (this.adjunto.estado_fds) formData.append('compliesDecree', this.adjunto.estado_fds);
          if (this.adjunto.no_cumple) formData.append('doesNotComply', this.adjunto.no_cumple);
          if (this.adjunto.observacion_no_cumple) formData.append('observationNoncompliance', this.adjunto.observacion_no_cumple);
          if (this.adjunto.idioma) formData.append('language', this.adjunto.idioma);
          if (this.adjunto.observacion) formData.append('comments', this.adjunto.observacion);
          if (this.adjunto.avatar) formData.append('file', this.adjunto.avatar);
          if (this.empresa.id) formData.append('company_updated_id', this.empresa.id);

          this.setCumpleDecretoAdjunto(this.adjunto.estado_fds === 162 ? 'SI' : 'NO')


          formData.append('categoriasfisicas', JSON.stringify(this.sga.categoriasfisicas));
          formData.append('categoriassalud', JSON.stringify(this.sga.categoriassalud));
          formData.append('categoriasambiental', JSON.stringify(this.sga.categoriasambiental));
          formData.append('categoriasNpeligrosas', JSON.stringify(this.sga.categoriasNpeligrosas));

          formData.append('iconos', JSON.stringify(this.epps));

          await this.createProductByContractorCompany(formData).then(async (id_producto) => {
            await this.guardaAsignacion(id_producto)
            await this.guardaUbicacion({id_producto:id_producto,ubicaciones:this.selecionadosIds,id_empresa:this.empresa.id})
          })

          this.setModalLoader(false)

          this.$alertSuccess('Producto creado exitosamente');

          this.resetModal()

          // Limpiar datos
          this.setCompany({});

        } catch (e) {
          this.setModalLoader(false)

        }
      },
      async finalizar() {
        try {
          this.producto.verificado = 1;
          this.producto.asignado = 1;
          this.producto.pago = 1;
          this.producto.id_empresa = this.empresa.id;

          // Asignar los componentes temporales al producto
          this.producto.components = this.components;

          this.setModalLoader(true)
          await this.guardaProducto().then(async (id_producto) => {

            /**
             * Contorlar el proceso de guardado para el adjunto
             */
            const formData = new FormData();

            formData.append('action', 'CREATE');
            formData.append('idProduct', id_producto);
            formData.append('customProcess', true);

            if (this.adjunto.fecha) formData.append('date', this.adjunto.fecha);
            if (this.adjunto.tipo) formData.append('type', this.adjunto.tipo);
            if (this.adjunto.sistema) formData.append('system', this.adjunto.sistema);
            if (this.adjunto.estado_fds) formData.append('compliesDecree', this.adjunto.estado_fds);
            if (this.adjunto.no_cumple) formData.append('doesNotComply', this.adjunto.no_cumple);
            if (this.adjunto.observacion_no_cumple) formData.append('observationNoncompliance', this.adjunto.observacion_no_cumple);
            if (this.adjunto.idioma) formData.append('language', this.adjunto.idioma);
            if (this.adjunto.observacion) formData.append('comments', this.adjunto.observacion);
            if (this.adjunto.avatar) formData.append('file', this.adjunto.avatar);
            if (this.empresa.id) formData.append('company_updated_id', this.empresa.id);

            this.setCumpleDecretoAdjunto(this.adjunto.estado_fds === 162 ? 'SI' : 'NO')

            await this.saveAttachment({ data: formData, params: {} }).then(async () => {
              if (this.producto.components.length){
                const payload = {
                  attachment_id : this.attachmenteCreated.id,
                  product_id : this.attachmenteCreated.id_producto,
                  components: this.producto.components.map(comp => comp.id)
                }
                await this.addAttachmentstoComponents(payload);
              }
            })

            await this.guardaSga(id_producto)
            await this.guardaEppIconos(id_producto)
            await this.guardaAsignacion(id_producto)
            await this.guardaUbicacion({id_producto:id_producto,ubicaciones:this.selecionadosIds,id_empresa:this.empresa.id})
          })

          this.setModalLoader(false)

          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Producto creado exitosamente',
            showConfirmButton: false,
            timer: 2000
          })

          this.resetModal()

          // Limpiar datos
          this.setCompany({});

        } catch (e) {
          this.setModalLoader(false)

          await Swal.fire({
            position: 'center',
            icon: 'error',
            title: e,
            timer: 5000
          })
        }
      },
      ...mapActions('pasoapaso', [
        'listarUbicaciones',
        'guardaProducto',
        'guardaAdjunto',
        'guardaSga',
        'guardaEppIconos',
        'guardaAsignacion',
        'guardaUbicacion',
         'createProductByContractorCompany'
      ]),
      ...mapActions('adjuntos', [
        'saveAttachment',
        'addAttachmentstoComponents'
      ]),
      ...mapMutations('pasoapaso', [
        'setModalPaso',
        'setModalVer',
        'addUbicacionSeleccionada',
        'setUbicacionesSeleccionadas',
        'setUbicacionesEmpresa',
        'setModalLoader',
        'resetModal',
        'setCumpleDecretoAdjunto',
        'setCompany'
      ]),

      handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        if (!this.selecionadosIds.includes(data.id)) {
          this.selecionadosIds.push(data.id);
        }
      } else {
        this.selecionadosIds = this.selecionadosIds.filter(function (item) {
          return item !== data.id;
        });
      }
    },
    }
  }
</script>

<style scoped>

  .padding-content{
      padding: 20px;
  }

  .el-checkbox__input .el-checkbox__inner {
    background-color: none;
    border-color: none;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: #ffffff;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #097b83;
    border-color: #097b83;
    color: #fff;
  }

  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #097b83;
    border-color: #097b83;
    color: #fff;
  }
</style>
